import { Link, Route, Routes } from 'react-router-dom';
import Compose from './pages/Compose.jsx';
import Sent from './pages/Sent.jsx';
import View from './pages/View.jsx';
import Forward from './pages/Forward.jsx';
import Chain from './pages/Chain.jsx';
import Privacy from './pages/Privacy.jsx';
import Admin from './pages/Admin.jsx';
import NotFound from './pages/NotFound.jsx';

export default function App() {
  return (
    <div className="min-h-screen flex flex-col">
      <header className="px-6 py-5 flex items-center justify-between max-w-3xl mx-auto w-full">
        <Link to="/" className="flex items-center gap-2 no-underline">
          <span className="text-2xl">💛</span>
          <span className="font-display font-bold text-xl text-navy">
            KindKudos
          </span>
        </Link>
        <nav className="text-sm">
          <Link to="/privacy" className="text-navy-700 no-underline hover:underline">
            Privacy
          </Link>
        </nav>
      </header>

      <main className="flex-1 px-6 pb-16 w-full max-w-3xl mx-auto">
        <Routes>
          <Route path="/" element={<Compose />} />
          <Route path="/sent" element={<Sent />} />
          <Route path="/k/:id" element={<View />} />
          <Route path="/k/:id/forward" element={<Forward />} />
          <Route path="/chain/:rootId" element={<Chain />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>

      <footer className="px-6 py-8 text-center text-sm text-navy-500">
        Send a little kindness. Anonymously. ·{' '}
        <Link to="/privacy" className="text-navy-700 no-underline hover:underline">
          Privacy
        </Link>
      </footer>
    </div>
  );
}
